import React, {Component} from "react";
import {Route, Switch, withRouter} from "react-router-dom";
import AssetTask from "./Asset_task";
import AssetIPSLocation from "./Asset_IPSLocation";
import AssetSelected from "./Asset_Selected";
import AssetIpsSelected from "./Asset_IPSLoc_selected";
import Tasks from '../../Tasks/container';
import {projectStatusMap} from "../../../components/ProjectStatusMap";
import PageTitle from "../../../components/FormHeader";
import {Col} from "react-flexbox-grid";
import {Radio} from 'antd';
import {spinnerOff, spinnerOn} from "../../../components/Spinner";
import {deleteProjectAsset, getAssetsBySectionId} from "../../../api";
import {Row} from "react-bootstrap";
import {BootstrapTable as Table} from "react-bootstrap-table";

class AssetDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: "allsections",
            assets: [],
            projectStatus: this.getProjectStatus(props.project),
            selectedAsset: null,
            project: props.project,
        };
        this.refreshAssets = this.refreshAssets.bind(this);
    }


    render() {
        const {location, history} = this.props;
        const {projectStatus, project} = this.state;
        const {id} = this.props.project;
        const isSection = Array.isArray(location.pathname.match(/allsections/g));
        const isIps = Array.isArray(location.pathname.match(/ipslocations/g));

        return (
            <div>
                {/*<Col className="title-name" xs={9}>*/}
                {/*    <PageTitle title={this.state.project.stationName}/>*/}
                {/*</Col>*/}
                <div className="row asset-task-header" style={{justifyContent: 'center'}}>
                  <Radio.Group onChange={(event) => {
                                this.setState({
                                  selected: event.target.value
                                });
                                history.push(`/${projectStatus}/${id}/assettasks/${event.target.value}`)}}
                               value={this.state.selected}
                  style={{display: "flex", flexDirection: "row",width:'243px'}}>
                    <Radio id="radio-1"
                           value="allsections">
                      All Sections
                    </Radio>
                    <Radio  id="radio-2"
                            value="ipslocations">
                      IPS Locations
                    </Radio>
                  </Radio.Group>
                </div>

                <Switch location={location}>

                    <Route
                        exact
                        key="asset-section"
                        path={`/:state/:projectId/assettasks/allsections`}
                        component={() =>
                            <AssetTask
                                pageName={this.state.sectionsPageName}
                                project={this.props.project}
                                setSelectedAssets={(assets) => this.setSelectedAssets(assets)}
                                setSelectedSection={(section) => this.setSelectedSection(section)}
                            />}
                    />
                    <Route
                        exact
                        key="asset-section"
                        path={`/:state/:projectId/assettasks/allsections/:sectionId`}
                        component={() => <AssetSelected
                            project={this.props.project}
                            assets={this.state.assets}
                            section={this.state.selectedSection}
                            setSelectedAsset={(asset) => this.setSelectedAsset(asset)}
                            refreshAssets={(assets)=>this.refreshAssets(assets)}
                        />}
                    />
                    <Route
                        exact
                        key="asset-ips"
                        path={`/:state/:projectId/assettasks/ipslocations`}
                        component={() => <AssetIPSLocation
                            pageName={this.state.ipsPageName}
                            project={this.props.project}
                            setSelectedAssets={(assets) => this.setSelectedAssets(assets)}
                            setSelectedIpsLocation={(ipslocation) => this.setSelectedIpsLocation(ipslocation)}
                        />}
                    />
                    <Route
                        exact
                        key="asset-ips"
                        path={`/:state/:projectId/assettasks/ipslocations/:ipsLocationId`}
                        component={() =>
                            <AssetIpsSelected
                                project={this.props.project}
                                assets={this.state.assets}                                
                                ipsLocation={this.state.selectedIpsLocation}
                                setSelectedAsset={(asset) => this.setSelectedAsset(asset)}
                                refreshAssets={(assets)=>this.refreshAssets(assets)}
                            />}
                    />
                    <Route
                        exact
                        path={`/:state/:projectId/assettasks/:filter/:assetId/tasks`}
                        component={() =>
                            <Tasks section={this.state.selectedSection}
                                ipsLocation={this.state.selectedIpsLocation}
                                   project={project}
                            />}
                    />
                    <Route
                        exact
                        key="asset-section"
                        path={`/:state/:projectId/assettasks`}
                        component={() =>
                            (this.state.selected === 'allsections') ?
                                <AssetTask
                                    pageName={this.state.sectionsPageName}
                                    project={this.props.project}
                                    setSelectedAssets={(assets) => this.setSelectedAssets(assets)}
                                    setSelectedSection={(section) => this.setSelectedSection(section)}
                                />
                            :
                                <AssetIPSLocation
                                    pageName={this.state.ipsPageName}
                                    project={this.props.project}
                                    setSelectedAssets={(assets) => this.setSelectedAssets(assets)}
                                    setSelectedIpsLocation={(ipslocation) => this.setSelectedIpsLocation(ipslocation)}
                                />
                        }
                    />


                </Switch>

            </div>
        );
    }

    setSelectedAssets(assets) {
        this.setState({
            assets: assets
        })
    }

    async refreshAssets(assets) {
        
        this.setState({
            assets: assets
        })
    }

    setSelectedSection(section) {
        this.setState({
            selectedSection: section
        })
    }

    setSelectedIpsLocation(ipsLocation) {
        this.setState({
            selectedIpsLocation: ipsLocation
        })
    }

    getProjectStatus(project) {
        return projectStatusMap[project.projectStatus]
    }

    setSelectedAsset(asset) {
        this.setState({
            selectedAsset: asset
        })
    }
}

export default withRouter(AssetDetails);
